
import React from "react";
import { Link, NavLink } from "react-router-dom";
import { Leaf, Home, User, LogIn, FolderOpen, ShieldCheck, MessageSquare } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/context/auth";
import { useUserRoles } from "@/hooks/useUserRoles";
import LogoutButton from "@/components/Auth/LogoutButton";


const Header: React.FC = () => {
  const { user } = useAuth();
  const { isAdmin } = useUserRoles();

  return <header className="sticky top-0 z-50 w-full hero-dark-gradient text-on-hero border-b border-white/10 backdrop-blur-sm shadow-sm">
      <div className="flex h-16 items-center justify-between px-4 md:px-6">
        <div className="flex items-center gap-2">
          <Link to="/" className="flex items-center gap-2 font-semibold text-terracotta-500">
            <Leaf className="h-6 w-6" />
            <span className="hidden md:inline-block">Arbetsmiljökontrollen</span>
          </Link>
        </div>
        <nav className="flex items-center gap-2">
          <NavLink to="/" aria-label="Hem">
            {({ isActive }) => (
              <Button variant="ghost" size="sm" className={`gap-2 text-on-hero text-glow hover:bg-white/10 ${isActive ? 'bg-white/15' : ''}`}>
                <Home className="h-4 w-4 icon-on-hero" />
                <span className="hidden md:inline-block">Hem</span>
              </Button>
            )}
          </NavLink>

          {user && (
            <NavLink to="/chat-hjalpen" aria-label="Chat hjälpen">
              {({ isActive }) => (
                <Button variant="ghost" size="sm" className={`gap-2 text-on-hero text-glow hover:bg-white/10 ${isActive ? 'bg-white/15' : ''}`}>
                  <MessageSquare className="h-4 w-4 icon-on-hero" />
                  <span className="hidden md:inline-block">Chat hjälpen</span>
                </Button>
              )}
            </NavLink>
          )}
          
          {user && (
            <NavLink to="/uppdrag" aria-label="Mina uppdrag">
              {({ isActive }) => (
                <Button variant="ghost" size="sm" className={`gap-2 text-on-hero text-glow hover:bg-white/10 ${isActive ? 'bg-white/15' : ''}`}>
                  <FolderOpen className="h-4 w-4 icon-on-hero" />
                  <span className="hidden md:inline-block">Mina uppdrag</span>
                </Button>
              )}
            </NavLink>
          )}
          {isAdmin && (
            <NavLink to="/admin" aria-label="Admin">
              {({ isActive }) => (
                <Button variant="ghost" size="sm" className={`gap-2 text-on-hero text-glow hover:bg-white/10 ${isActive ? 'bg-white/15' : ''}`}>
                  <ShieldCheck className="h-4 w-4 icon-on-hero" />
                  <span className="hidden md:inline-block">Admin</span>
                </Button>
              )}
            </NavLink>
          )}
          
          {user ? <>
              <NavLink to="/profile" aria-label="Profil">
                {({ isActive }) => (
                  <Button variant="ghost" size="sm" className={`gap-2 text-on-hero text-glow hover:bg-white/10 ${isActive ? 'bg-white/15' : ''}`}>
                    <User className="h-4 w-4 icon-on-hero" />
                    <span className="hidden md:inline-block">{user.first_name || 'Profil'}</span>
                  </Button>
                )}
              </NavLink>
              <LogoutButton 
                variant="hero-outline" 
                className="ml-2" 
              />
            </> : <Link to="/auth">
              <Button variant="hero-outline" size="sm" className="gap-2 ml-2">
                <LogIn className="h-4 w-4 icon-on-hero" />
                <span className="sm:inline-block">Logga in</span>
              </Button>
            </Link>}
            
          
        </nav>
      </div>
    </header>;
};

export default Header;
